__turbopack_context__.v({
  "chip": "fRpyrG_chip",
  "chip-active": "fRpyrG_chip-active",
  "chip-interactive": "fRpyrG_chip-interactive",
  "theme-danger": "fRpyrG_theme-danger",
  "theme-neutral": "fRpyrG_theme-neutral",
  "theme-primary": "fRpyrG_theme-primary",
  "theme-warning": "fRpyrG_theme-warning",
});
